module.exports = __webpack_public_path__ + "img/Line 735.29c38ad3.png";